<div class="form-field" [formGroup]='parent' 
[ngClass]="{'has-error': (parent.get(controllerData.controlName).touched
  && parent.get(controllerData.controlName).errors) || (parent.get(controllerData.controlName).hasError('invalidAge'))}" [attr.aria-describedBy]="'lbl-'+pageName+'-'+controllerData.controlName">
  <label [id]="'lbl-'+pageName+'-'+controllerData.controlName" [attr.for]="pageName+'-'+controllerData.controlName" class="form-label">{{controllerData['label']}}</label>
  
  <input [formControlName]="controllerData['controlName']" 
        [name]="controllerData['name']" aria-required="true" [attr.aria-invalid]="(parent.get(controllerData.controlName).touched && parent.get(controllerData.controlName).errors) ? true : false"  type="text" 
        [id]="pageName+'-'+controllerData['name']"
        [(ngModel)]="textValue"  
        [placeholder]="controllerData['placeHolder']" maxlength="14"
        (keypress)="addslash($event.target.value, $event)" 
        class="form-control"
        [ngClass]=" (router.url !== '/quote/your-product-options') ? 'modalClose-focus' : '' "
        [value]="textValue"
        [required]="controllerData['required']"
        (keyup.enter)="validateInput()"
        (blur)="validateInput()"
        [attr.aria-describedBy]="'input-'+pageName+'-'+controllerData.controlName"
        inputmode="numeric"
        />
        <!-- [ngClass]="{'form-disable':(logIn)}" -->
</div>
<!-- <div class="col-md-2 margin-top-2">
  <app-tool-tip-notification [tooltipData]="tooltipData"></app-tool-tip-notification>
</div> -->
<div class="row">
  <div class="form-validation-error" 
        *ngIf="parent.get(controllerData.controlName).touched
                          &&
              parent.get(controllerData.controlName).errors
                          &&
              !parent.get(controllerData.controlName).hasError('threeMonthsValid')
                          &&
              !parent.get(controllerData.controlName).hasError('invalidAge')" [id]= "'input-'+pageName+'-'+controllerData.controlName">
    <i class="icon icon-error" aria-hidden="true"></i>
    <p [id]="pageName+'-'+controllerData.controlName+'-error'" *ngIf="parent.get(controllerData.controlName).touched
                    &&
              parent.get(controllerData.controlName).hasError('required')" aria-hidden="false" role="error">
              {{controllerData['errorMessage']}}
    </p>
    <p [id]="pageName+'-'+controllerData.controlName+'-invalid-error'" *ngIf="parent.get(controllerData.controlName).touched
                    &&
              parent.get(controllerData.controlName).hasError('dobIsNotValid')" aria-hidden="false" role="error">
              {{controllerData['errorMessageInvalidDate']}}
    </p>
    <p [id]="pageName+'-'+controllerData.controlName+'-format-invalid-error'" *ngIf="parent.get(controllerData.controlName).touched
                    &&
              parent.get(controllerData.controlName).hasError('dobFormatInvalid')" aria-hidden="false" role="error">
              {{controllerData['errorMessageInvalidFormat']}}
    </p>
  </div>
</div>
<div class="form-validation-error" 
*ngIf="parent.get(controllerData.controlName).errors
                  &&
       (parent.get(controllerData.controlName).hasError('invalidAge')
       || parent.get(controllerData.controlName).hasError('threeMonthsValid'))" [id]= "'input-'+pageName+'-'+controllerData.controlName">
       <i class="icon icon-error" aria-hidden="true"></i>
       <p [id]="pageName+'-'+controllerData.controlName+'-format-invalid-error'" *ngIf="parent.get(controllerData.controlName).hasError('invalidAge')" aria-hidden="false" role="error">
            {{controllerData['StartDateAge55Error']}}
  </p>
  <p [id]="pageName+'-'+controllerData.controlName+'-format-invalid-error'" *ngIf="parent.get(controllerData.controlName).hasError('threeMonthsValid')" aria-hidden="false" role="error">
    {{controllerData['StartDateThreeMonthsError']}}
</p>
</div>

<!-- <label *ngIf="!parent.invalid">Valid Date</label>
<label *ngIf="parent.invalid">Invalid Date</label> -->
<!--<div *ngIf="parent.invalid" class="error-wrapper">
  <label class="ext-error-message">Invalid Date</label>
</div>
<br> -->
<!-- <label>{{dobSelected}}</label> -->